import React from "react";
import { DailyTab } from "./Daily";
import { UpdatesTab } from "./Updates";
import { MonthlyTab } from "./Monthly";

export const tabs = [
  { label: 'Statement View', component: <DailyTab /> },
  { label: 'Statement Updates', component: <UpdatesTab /> },
  { label: 'Monthly Statements', component: <MonthlyTab /> }
]